import { Lock } from 'lucide-react';
import { ApiError } from '@/lib/api/client';
import { Notice, QueryError } from './feedback';

/** True for the two answers that mean "this route is not yours", not "something broke". */
export function isForbidden(err: unknown): boolean {
  return ApiError.is(err) && (err.statusCode === 403 || err.statusCode === 404);
}

/**
 * A query on an "any member" route failed. A 403/404 is the backend keeping a
 * platform admin out of tenant data — said plainly, with what to ask for;
 * anything else is a real error with its request id.
 */
export function AccessOrError({ error, what, route, onRetry }: { error: unknown; what: string; route: string; onRetry?: () => void }) {
  if (isForbidden(error)) {
    return (
      <Notice tone="neutral" icon={<Lock size={16} />} title={`${what} недоступны администратору платформы`}>
        Маршрут <code className="font-mono">{route}</code> открыт участникам организации. Чтобы этот экран заработал, нужен админский эндпоинт — попросить бэкенд-команду.
      </Notice>
    );
  }
  return <QueryError error={error} onRetry={onRetry} />;
}
